import React, { useState } from "react"
import { useSelector, useDispatch } from 'react-redux'
import {
	CToast,CToastBody,CToastHeader,CToaster,
} from '@coreui/react';
import PropTypes from 'prop-types';
import { UFunc } from '../helpers/functions'

const MyToaster = props => {
    //const { toastData } 		= props;

	const uDispatch				= useDispatch();
	const uToastdataArr			= useSelector(state => state.listToast) || [];

  	//const [uToaserArr,setToaserArr]	= useState(toastData);
	const timerIds 				= React.useRef({});

  	const hdlCloseToastitem = React.useCallback((_TIMEID) => {
  		const vNewArr = uToastdataArr.filter((vItems) => 
  			vItems.timeId !== _TIMEID);
		uDispatch({type: "set", listToast: vNewArr});
  	},[uToastdataArr,uDispatch]);

	React.useEffect(() => { 
		return () => {
			uDispatch({type: "set", listToast: []});
		}
	},[]);//*/
	React.useEffect(() => {
		//console.log("(MyToaster - [uToastdataArr] => ",JSON.stringify(uToastdataArr));
		// Iterate over all current toasts in the Redux state
		uToastdataArr.forEach((toast) => {
			// Only set a timer if one doesn't already exist for this toast ID
			// Set the timeout to remove the toast from Redux
			const vTimeout = setTimeout(() => {
				clearTimeout(vTimeout);
				hdlCloseToastitem(toast.timeId)

				// Remove the timer ID from the reference after it fires
				//delete timerIds.current[toast.timeId];
			}, 5000);
			// Store the timer ID for cleanup/manual close
        });

		return () => {
            // Go through all stored timer IDs and clear them
            //Object.values(timerIds.current).forEach(clearTimeout);
            //timerIds.current = {}; // Reset the map
			//setToaserArr([])
		}
	},[uToastdataArr,uDispatch,hdlCloseToastitem]);
	
	//console.log("(MyToaster)  uToastdataArr = "+uToastdataArr.length);
	return (
		<>
		<CToaster placement="bottom-end">
		{uToastdataArr.map((vItems, vKeys)=>{
			const vTimevalueDT	= new Date(vItems.timeId.valueOf());
			let resultType;
			switch((vItems.type||"").toLowerCase()) {
				case "info": resultType = { class: "bg-info", title: "Informasi", }
					break;
				case "error": resultType = { class: "bg-danger", title: "Error", }
					break;
				case "sukses": resultType = { class: "bg-success", title: "Berhasil", }
					break;
				default: resultType = { class: "", title: "Informasi", }
			}

			return(
			<div key={vKeys}>
				<CToast onClose={()=>hdlCloseToastitem(vItems.timeId)}
					animation={true} 
					delay={3000}
					autohide={true}
					visible={true}>
					<CToastHeader
						className={resultType.class+" text-white font-weight-bolder"} 
						closeButton>
						<b className="me-auto">{(resultType.title)}</b>
						<small>{UFunc.JamMenit(vTimevalueDT)}</small>
					</CToastHeader>
					<CToastBody>
					{UFunc.renderHTML(vItems.teksIsi)}
					</CToastBody>
				</CToast>
			</div>
			)//>
		})}
		</CToaster>
		</>
	)//>
}
MyToaster.propTypes = {
	toastData: PropTypes.array,
}


export default MyToaster;
